import * as React from 'react';
export const KWSvg = React.forwardRef(function KWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M2 2v4h14V4c0-1.105-.897-2-2.006-2H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M7 6h9v4H7z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 10v4h11.994A1.998 1.998 0 0 0 16 12v-2H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M7 6v4l-4.995 4A1.996 1.996 0 0 1 0 12.008V3.992A2 2 0 0 1 2.005 2L7 6Z',
      }),
    ),
  );
});
KWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KW = {
  category: 'flag',
  colorable: false,
  name: 'KW',
  svg: KWSvg,
};
